import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {MedicalRecordGeneralInformationModel} from '../model/medicalRecordGeneralInformation.model';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class MedicalRecordGeneralInformationConverter extends HttpModelConverter<MedicalRecordGeneralInformationModel>{

    constructor(private partnerSummaryConverter: PartnerSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): MedicalRecordGeneralInformationModel {
        return new MedicalRecordGeneralInformationModel();
    }

    protected enrichObject(result: MedicalRecordGeneralInformationModel, src: MedicalRecordGeneralInformationModel) {
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.allergies = this.lovValueSummaryConverter.convertFromArray(src.allergies);
        result.medications = this.lovValueSummaryConverter.convertFromArray(src.medications);
        result.poisonings = this.lovValueSummaryConverter.convertFromArray(src.poisonings);
        result.senseTroubles = this.lovValueSummaryConverter.convertFromArray(src.senseTroubles);
        result.shoeType = this.lovValueSummaryConverter.convert(src.shoeType);
        result.dominantFoot = this.lovValueSummaryConverter.convert(src.dominantFoot);
        result.dominantHand = this.lovValueSummaryConverter.convert(src.dominantHand);
    }
}
